module.exports = __webpack_public_path__ + "static/media/left-chevron.8f7d8890.svg";